import React from 'react';
import { useOnboarding } from './OnboardingProvider';
import TheSessionImportModalUI from '../components/TheSessionImportModal';

// Onboarding wrapper around the shared TheSession import modal.
// Shown automatically after the wizard when the user selected Irish genres.
// Dismisses via the onboarding context so the prompt doesn't reappear.
export default function TheSessionImportModal() {
  const { dismissTheSessionPrompt } = useOnboarding();
  return <TheSessionImportModalUI onClose={dismissTheSessionPrompt} />;
}
